import React from "react";

import { ContentCard } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  contentCardCss,
  textualContainer,
  titleCss,
  tagCss,
  metadataTagsCss,
} from "./KnowledgeEntityCard.style";

const knowledgeEntityCardProps = {
  subtitle: PropTypes.string,
  title: PropTypes.string,
  content_counts_by_type: PropTypes.object,
};

const MEMBER_TYPES = {
  ARTICLEHEADER: "articleheader",
  TEXTSET: "textset",
  VIDEO: "video",
};

const MEMBER_MAPPING = {
  [MEMBER_TYPES.ARTICLEHEADER]: "article",
  [MEMBER_TYPES.TEXTSET]: "textset",
  [MEMBER_TYPES.VIDEO]: "Video",
};

export const KnowledgeEntityCard = React.forwardRef((props, ref) => {
  KnowledgeEntityCard.displayName = "KnowledgeEntityCard";

  const {
    title,
    subtitle,
    content_counts_by_type: contentCountsByType,
  } = props;

  const getMetadata = () => {
    const { ARTICLEHEADER, TEXTSET } = MEMBER_TYPES;
    const metadataTextFields = [ARTICLEHEADER, TEXTSET];

    const { metadataText, metadataTags } = Object.entries(
      contentCountsByType,
    ).reduce(
      (sections, [key, value]) => {
        if (!value || !MEMBER_MAPPING[key]) {
          return sections;
        }

        const memberType =
          value === 1 ? MEMBER_MAPPING[key] : `${MEMBER_MAPPING[key]}s`;

        if (metadataTextFields.includes(key)) {
          sections.metadataText.push(
            <>
              <b>{value}</b> {memberType}
            </>,
          );
        } else {
          sections.metadataTags.push(<div css={tagCss}>{memberType}</div>);
        }

        return sections;
      },
      { metadataText: [], metadataTags: [] },
    );

    return (
      <div>
        {!!metadataText.length &&
          metadataText.reduce((prev, curr) => [prev, " and ", curr])}
        <div css={metadataTagsCss}>{metadataTags}</div>
      </div>
    );
  };

  const renderTextual = () => {
    return (
      <div css={textualContainer}>
        <h2 css={titleCss}>{title}</h2>
        {contentCountsByType && !!Object.keys(contentCountsByType).length
          ? getMetadata()
          : subtitle}
      </div>
    );
  };

  return (
    <ContentCard
      {...props}
      __css={contentCardCss}
      __renderTextual={renderTextual}
      contentType="Knowledge Entity Card"
      footer={<></>}
      ref={ref}
    />
  );
});

KnowledgeEntityCard.propTypes = knowledgeEntityCardProps;
KnowledgeEntityCard.defaultProps = {
  isVertical: ContentCard.defaultProps.isVertical,
};
export default KnowledgeEntityCard;
